export interface Bonus {
  title: string
  description: string
  price: string
  image: string
}

export const bonuses: Bonus[] = [
  {
    title: 'Baza Rozgrzewek i Gier',
    description: 'Ponad 50 gotowych propozycji na start treningu',
    price: '49 zł',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/52e0024f-0007-4123-b060-87470d259c4b.jpg',
  },
  {
    title: 'Zestaw Testów i Ocena Zawodnika',
    description: 'Zmierz postępy każdego gracza',
    price: '39 zł',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2b39dd44-ddb0-420d-b5d5-af00d600abba.jpg',
  },
  {
    title: 'Przygotowanie Fizyczne i Zapobieganie Kontuzjom',
    description: 'Gotowe rutyny siły, mocy i mobilności',
    price: '45 zł',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/539f7010-0a5a-4be2-beec-152b5f54866f.jpg',
  },
  {
    title: 'Przepisy Gry — Ilustrowany Przewodnik',
    description: 'Zasady i sygnały wyjaśnione obrazkowo',
    price: '29 zł',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/fa33feb3-69fb-4702-bd88-15a13ede10af.jpg',
  },
  {
    title: 'Zarządzanie Zespołem i Komunikacja',
    description: 'Buduj zgraną drużynę i rozmawiaj z rodzicami',
    price: '37 zł',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/d0f647f0-9d45-4cfe-95be-bbcffd5f6bbe.jpg',
  },
]
